import { msalConfig } from '../utils/msalConfig';
import { authAPI } from './apiService';

export const createTeamsMeeting = async (meetingData, accessToken) => {
    try {
        const meetingPayload = {
            subject: meetingData.title,
            body: {
                contentType: "HTML",  
                content: meetingData.description
            },
            start:{
                dateTime:`${meetingData.date}T${meetingData.startTime}:00`,
                timeZone: "Africa/Johannesburg"
            },


            end:{
                dateTime: `${meetingData.date}T${meetingData.endTime}:00`,
                timeZone: "Africa/Johannesburg"
            },
            
            isOnlineMeeting: true,
            onlineMeetingProvider: "teamsForBusiness",
            allowNewTimeProposals: false,
            sensitivity: "private",
            location:{
                displayName:meetingData.selectedRoom.displayName,
                locationEmailAddress: meetingData.selectedRoom.emailAddress,
                locationType: "conferenceRoom",
                uniqueId: meetingData.selectedRoom.emailAddress,
                uniqueIdType: 'directory',
                address: {
                    countryOrRegion: 'ZA',
                  }
            },
            locations: [
                {
                  displayName: meetingData.selectedRoom.displayName,
                  locationUri: meetingData.selectedRoom.emailAddress,
                  locationType: 'conferenceRoom',
                  uniqueId: meetingData.selectedRoom.emailAddress,
                  address: {
                    countryOrRegion: 'ZA'
                  },
                },
              ],
            attendees: [{
                emailAddress: {
                    address: meetingData.selectedRoom.emailAddress
                }
            }]
        }



        const response = await fetch('https://graph.microsoft.com/v1.0/me/events', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(meetingPayload)
        });
        if (!response.ok) {
            const errorText = await response.text();
            console.error('API Error Response:', errorText);
            throw new Error(`API Error: ${response.status} - ${errorText}`);
        }

        const teamsData = await response.json();


        const calendarEvent = {
            ...meetingData,
            teamsLink: teamsData.onlineMeeting.joinUrl
        };

        if (meetingData.selectedRoom) {
            calendarEvent.location = {
                displayName: meetingData.selectedRoom.displayName,
                locationEmailAddress: meetingData.selectedRoom.emailAddress,
                locationType: "conferenceRoom"
            };
            calendarEvent.attendees = [{
                emailAddress: {
                    address: meetingData.selectedRoom.emailAddress
                },
                type: "resource"
            }];
        }
        return {
            ...meetingData,
            teamsLink: teamsData.onlineMeeting.joinUrl,
            meetingId: teamsData.id,
            data:teamsData 
        };
    } catch (error) {
        console.error('Teams API error:', error);
        throw error;
    }
};

export const cancelMeeting = async (eventId, accessToken) => {
    try {


        const calendarResponse = await fetch(`https://graph.microsoft.com/v1.0/me/events/${eventId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });

        if (!calendarResponse.ok) {
            const errorText = await calendarResponse.text();
            throw new Error(`Failed to cancel meeting: ${errorText}`);
        }

        return true;
    } catch (error) {
        console.error('Cancel meeting error:', error);
        throw error;
    }
};


export const checkRoomAvailability = async (roomEmail, startTime, endTime, accessToken) => {
    try {
        const response = await fetch(`https://graph.microsoft.com/v1.0/users/${roomEmail}/calendar/getSchedule`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                schedules: [roomEmail],
                startTime: {
                    dateTime: startTime,
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                },
                endTime: {
                    dateTime: endTime,
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                }
            })
        });

        if (!response.ok) {
            throw new Error('Failed to check room availability');
        }

        const availabilityData = await response.json();
        return availabilityData.value[0].availabilityView === "0".repeat(availabilityData.value[0].availabilityView.length);
    } catch (error) {
        console.error('Error checking room availability:', error);
        throw error;
    }
};

export const fetchAvailableRooms = async (accessToken) => {
    try {
        // First, get room lists
        const roomListResponse = await fetch('https://graph.microsoft.com/v1.0/places/microsoft.graph.roomList', {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });

        if (!roomListResponse.ok) {
            throw new Error('Failed to fetch room lists');
        }

        const roomLists = await roomListResponse.json();

        // Then get rooms from each room list
        let allRooms = [];
        for (const roomList of roomLists.value) {
            const roomsResponse = await fetch(`https://graph.microsoft.com/v1.0/places/${roomList.id}/microsoft.graph.room`, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }
            });

            if (roomsResponse.ok) {
                const rooms = await roomsResponse.json();
                allRooms = [...allRooms, ...rooms.value];
            }
        }

        return allRooms;
    } catch (error) {
        console.error('Error fetching rooms:', error);
        throw error;
    }
};

export const addToCalendar = async (meetingData, accessToken) => {
    try {
        const eventBody = {
            subject: meetingData.title,
            start: {
                dateTime: `${meetingData.date}T${meetingData.startTime}`,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            end: {
                dateTime: `${meetingData.date}T${meetingData.endTime}`,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
            },
            body: {
                contentType: "text",
                content: `${meetingData.description}\n\nJoin Teams Meeting: ${meetingData.teamsLink}`
            },
            isOnlineMeeting: true,
            onlineMeetingProvider: "teamsForBusiness"
        };


        if (meetingData.location) {
            eventBody.location = meetingData.location;
        }
        if (meetingData.attendees) {
            eventBody.attendees = meetingData.attendees;
        }


        const response = await fetch('https://graph.microsoft.com/v1.0/me/events', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({eventBody})
        });


        if (!response.ok) {
            throw new Error('Failed to add event to calendar');
        }

        return await response.json();
    } catch (error) {
        console.error('Calendar API error:', error);
        throw error;
    }
};

export const deleteTeamsMeeting = async (meetingId, accessToken) => {
    try {
        const response = await fetch(`https://graph.microsoft.com/v1.0/me/onlineMeetings/${meetingId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });

        if (!response.ok) {
            throw new Error('Failed to delete Teams meeting');
        }

        return true;
    } catch (error) {
        console.error('Teams API error:', error);
        throw error;
    }
};


export const fetchAccessToken = async () => {
    try {
        const data = await authAPI.getToken();
        return data.accessToken;
    } catch (error) {
        console.error('Error fetching access token:', error);
        return null;
    }
};

export const getEventAttendees = async (userId, eventId) => {
    const accessToken = await fetchAccessToken();
    const url = `https://graph.microsoft.com/v1.0/users/${userId}/events/${eventId}?$select=attendees`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        const rsvp_list = data.attendees.filter(attendee => attendee.status.response !== "declined").map(attendee => ({email: attendee.emailAddress.address,name: attendee.emailAddress.name}));

        return rsvp_list;

    } catch (error) {
        console.error('Error fetching attendees:', error);
        throw error;
    }
};


export const getUserId = (userDetails) => {
    return userDetails[0]?.idTokenClaims?.oid || null;
};

export const updateTeamsMeeting = async (meetingData, userDetails, eventId) => {
    try {
        const accessToken = await fetchAccessToken();
        if (!accessToken) {
            console.error('No access token available');
            return;
        }


        const userId = meetingData.accessToken;
        if (!userId) {
            console.error('No user ID available');
            return;
        }

        // Create the meeting payload with proper attendee handling
        const meetingPayload = {
            attendees: [
                // Add all current attendees
                ...meetingData.rsvp_list.map(attendee => ({
                    emailAddress: {
                        address: typeof attendee === 'object' ? attendee.email : attendee,
                        name: typeof attendee === 'object' ? attendee.name : undefined
                    },
                    type: "required"
                }))
            ]
        };
        
        // Update the event with notifications
        const url = `https://graph.microsoft.com/v1.0/users/${userId}/events/${eventId}?sendUpdates=none`;

        const updateResponse = await fetch(url, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(meetingPayload)
        });

        if (!updateResponse.ok) {
            const errorText = await updateResponse.text();
            console.error('API Error Response:', errorText);
            throw new Error(`API Error: ${updateResponse.status} - ${errorText}`);
        }

        return await updateResponse.json();
    } catch (error) {
        console.error('Error updating meeting:', error);
        throw error;
    }
};

export const updateMeetingDetails = async (meetingData, eventId) => {
    try {
        const accessToken = await fetchAccessToken();
        if (!accessToken) {
            console.error('No access token available');
            return;
        }

        const userId = meetingData.accessToken;
        if (!userId) {
            console.error('No user ID available');
            return;
        }


        const meetingPayload = {
            subject: meetingData.title,
            body: {
                contentType: "HTML",
                content: meetingData.description
            },
            start: {
                dateTime: `${meetingData.date}T${meetingData.start_time}:00`,
                timeZone: "Africa/Johannesburg"
            },
            end: {
                dateTime: `${meetingData.date}T${meetingData.end_time}:00`,
                timeZone: "Africa/Johannesburg"
            }
        };


        
        const url = `https://graph.microsoft.com/v1.0/users/${userId}/events/${eventId}?sendUpdates=all`;

        const updateResponse = await fetch(url, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(meetingPayload)
        });

        if (!updateResponse.ok) {
            const errorText = await updateResponse.text();
            console.error('API Error Response:', errorText);
            throw new Error(`API Error: ${updateResponse.status} - ${errorText}`);
        }

        const updatedEvent = await updateResponse.json();
        return updatedEvent;

    } catch (error) {
        console.error('Error updating meeting details:', error);
        throw error;
    }
};

export const sendCalendarInvite = async (meetingData, attendeeEmail, accessToken) => {
    try {
        const response = await fetch('https://graph.microsoft.com/v1.0/me/events', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                subject: meetingData.title,
                start: {
                    dateTime: `${meetingData.date}T${meetingData.startTime}`,
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                },
                end: {
                    dateTime: `${meetingData.date}T${meetingData.endTime}`,
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                },
                body: {
                    contentType: "text",
                    content: `${meetingData.description}\n\nJoin Teams Meeting: ${meetingData.teamsLink}`
                },
                attendees: [{
                    emailAddress: {
                        address: attendeeEmail
                    },
                    type: "required"
                }],
                isOnlineMeeting: true,
                onlineMeetingProvider: "teamsForBusiness"
            })
        });

        if (!response.ok) {
            throw new Error('Failed to send calendar invite');
        }

        return await response.json();
    } catch (error) {
        console.error('Calendar invite error:', error);
        throw error;
    }
};